<template>
  <IconLucideBellRing />
</template>
